
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.547","height":"16.584"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.707 15.877l1.1-4.114a7.612 7.612 0 113.032 3.006z","fill":"none","stroke":"#5686f6"}}),_c('path',{attrs:{"d":"M11.277 9.15a1.273 1.273 0 00-1.088-.245c-.283.115-.463.558-.646.784a.273.273 0 01-.351.075 4.923 4.923 0 01-2.458-2.106.3.3 0 01.038-.412 1.666 1.666 0 00.446-.725 1.586 1.586 0 00-.2-.858 2.033 2.033 0 00-.633-.954.868.868 0 00-.943.14 1.913 1.913 0 00-.664 1.516 2.159 2.159 0 00.06.481 3.991 3.991 0 00.461 1.064 8.535 8.535 0 00.482.732 7.438 7.438 0 002.091 1.941 6.293 6.293 0 001.3.62 2.9 2.9 0 001.517.24 1.839 1.839 0 001.376-1.024.89.89 0 00.064-.522c-.078-.359-.565-.574-.857-.747","fill":"#5686f6","fill-rule":"evenodd"}})])
          )
        }
      }
    